<template>
  <div class="table">
    <div class="tr th">
      <span>Item</span>
      <span>Amount</span>
    </div>
    <div
      v-for="(inItem, index) in displayExcessList"
      :key="index"
      class="tr">
      <span>{{ inItem.item }}</span>
      <span>
        <template v-if="inItem.changed">
          <span class="flex-center">
            <span class="old-value flex-1">{{ inItem.oldPremium || '-' }}</span>
            <span class="new-value flex-1">{{ inItem.premium }}</span>
          </span>
        </template>
        <template v-else>
          {{ inItem.premium }}
        </template>
      </span>
    </div>
  </div>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'

export default {
  name: 'ExcessInfo',
  mixins: [MixinOptions, MixinFormat],
  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
    quoteCoverageList: {
      type: Object,
      default: () => ({})
    },
    isAdjust: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    classId() {
      return this.formData.class_id
    },
    currentExcessList() {
      const source = this.isAdjust ? this.quoteCoverageList : this.formData
      return this.extractExcessSubItems(source)
    },
    oldExcessList() {
      if (!this.isAdjust) return []
      return this.extractExcessSubItems(this.formData)
    },
    // 最终用于渲染的列表，包含对比结果
    displayExcessList() {
      if (!this.isAdjust) {
        return this.currentExcessList.map(item => ({ ...item, changed: false }))
      }
      const commonItems = this.currentExcessList.filter(inItem => {
        return this.oldExcessList.some(oldItem => oldItem.item === inItem.item)
      })

      return commonItems.map(inItem => {
        const oldItem = this.oldExcessList.find(oldItem => oldItem.item === inItem.item)
        const oldPremium = oldItem ? oldItem.premium : ''
        const newPremium = inItem.premium
        const changed = oldPremium !== newPremium

        return {
          ...inItem,
          oldPremium,
          changed
        }
      })
    }
  },
  methods: {
    extractExcessSubItems(data) {
      if (!data) return []
      if (data.excess && data.excess.items && data.excess.items[0] && data.excess.items[0].sub_items) {
        return data.excess.items[0].sub_items
      }
      // 兼容旧结构：data.quote_coverage_list.excess
      if (data.quote_coverage_list && data.quote_coverage_list.excess && data.quote_coverage_list.excess.items && data.quote_coverage_list.excess.items[0] && data.quote_coverage_list.excess.items[0].sub_items) {
        return data.quote_coverage_list.excess.items[0].sub_items
      }
      return []
    },
    submitInfo() {
      const {
        tppd_ex,
        tppd_young_driver_ex,
        tppd_inexp_driver_ex,
        tppd_unnamed_driver_ex,
        remark,
        general_ex,
        general_ex_posi,
        general_ex_or_pol,
        china_general_ex,
        china_general_ex_posi,
        china_general_ex_or_pol,
        theft_loss_ex,
        theft_loss_ex_posi,
        theft_loss_ex_or_pol,
        china_theft_loss_ex,
        china_theft_loss_ex_posi,
        china_theft_loss_ex_or_pol,
        parking_damage_ex,
        young_driver_ex,
        inexp_driver_ex,
        unnamed_driver_ex,
        gd_general_ex,
        gd_general_ex_or_pol,
        gd_general_ex_posi,
        gd_theft_loss_ex,
        gd_theft_loss_ex_or_pol,
        gd_theft_loss_ex_posi
      } = this.formData
      return {
        tppd_ex,
        tppd_young_driver_ex,
        tppd_inexp_driver_ex,
        tppd_unnamed_driver_ex,
        remark,
        general_ex,
        general_ex_posi,
        general_ex_or_pol,
        china_general_ex,
        china_general_ex_posi,
        china_general_ex_or_pol,
        theft_loss_ex,
        theft_loss_ex_posi,
        theft_loss_ex_or_pol,
        china_theft_loss_ex,
        china_theft_loss_ex_posi,
        china_theft_loss_ex_or_pol,
        parking_damage_ex,
        young_driver_ex,
        inexp_driver_ex,
        unnamed_driver_ex,
        gd_general_ex,
        gd_general_ex_or_pol,
        gd_general_ex_posi,
        gd_theft_loss_ex,
        gd_theft_loss_ex_posi,
        gd_theft_loss_ex_or_pol
      }
    }
  }
}
</script>

<style scoped lang="scss">
.old-value {
  color: $red;
  text-decoration: line-through;
  margin-right: 8px;
}
.new-value {
  color: $green;
}
</style>